import { useEffect, useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { vendorApi } from '@/utils/vendorApi';
import { ALL_BUSINESS_UNITS_ID } from '@/utils/businessUnits';

/** Matches vendor_tags.NO_TAG. Not a real tag name. */
export const NO_VENDOR_TAG = '__none__';

/** Tags defined for the header's business unit, or every visible unit when All is selected. */
export function useCatalogTags(): string[] {
  const { authorization, currentBusinessUnit } = useAuthStore();
  const [tags, setTags] = useState<string[]>([]);

  useEffect(() => {
    if (!authorization) {
      setTags([]);
      return;
    }
    const selected = currentBusinessUnit?.id;
    const ids = !selected || selected === ALL_BUSINESS_UNITS_ID
      ? (authorization.globalAdmin
        ? authorization.catalog.map((entry) => entry.id)
        : authorization.units.map((unit) => unit.id))
      : [selected];
    let cancelled = false;
    Promise.all(ids.map((id) => vendorApi.listTags(id).catch(() => [] as string[])))
      .then((lists) => {
        if (cancelled) {
          return;
        }
        const names = Array.from(new Set(lists.flat()));
        names.sort((left, right) => left.localeCompare(right, undefined, { sensitivity: 'base' }));
        setTags(names);
      });
    return () => {
      cancelled = true;
    };
  }, [authorization, currentBusinessUnit]);

  return tags;
}

export function tagFilterParam(value: string): string | undefined {
  return value === 'all' ? undefined : value;
}

export function tagSelectOptions(tags: string[]): { value: string; label: string }[] {
  return [
    { value: 'all', label: 'All tags' },
    { value: NO_VENDOR_TAG, label: 'No tag' },
    ...tags.map((tag) => ({ value: tag, label: tag })),
  ];
}
